module.exports = __webpack_public_path__ + "img/inform-icon.d6858572.svg";